<template>
    <div>
        <v-row class="px-2 pt-2">
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    @change="getChart"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="px-2">
            <v-col md="12" class="pa-2" align="center">
                <chart
                    v-if="chartData && chartData.length"
                    ref="chart"
                    :chartData="chartData"
                ></chart>
                <span v-else>No transactional data for the past 12 weeks.</span>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import Chart from '@/components/reports/charts/Merchants12WeekRevenue.vue';

export default {
    components: {
        'chart': Chart,
    },
    data() {
        return {
            merchants: null,
            merchant: null,
            chartData: null
        }
    },
    beforeMount() {
        this.getMerchants();
    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 3) {
                axios({
                method: 'get',
                url: `get-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.merchant = this.merchants.length >= 1 ? this.merchants[0] : null;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getChart() {
            axios({
            method: 'post',
            url: `report-merchants-12-week-revenue`,
            data: { merchant: this.merchant },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
}
</script>